import React, { useEffect, useState } from 'react'
import DisplayEmployeeNameContainer from '../../../containers/DisplayEmployeeName';
import ReportModalContainer from '../../../containers/ReportModal';
import _reports from "../../../images/reports.svg";

const MyReportPage = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);

    const {
        reports
    } = props;


    useEffect(() => {
        if (!isOpen) {
            setSelectedReport(null);
        }
    }, [isOpen])

    const onCardClick = (reportData) => {
        setSelectedReport(reportData);
        setIsOpen(true);
    }

    const onLevelSelect = (level) => {
        props.getLelvelItemsForLevel(level);
    }

    const onRegionSelect = (regionId) => {
        props.getCompanyLocationsByRegion(regionId);
    }

    useEffect(() => {
        props.getCompanyLevels()
    }, [])


    return (
        <>

            <div className="Dashboard-Content">
                <DisplayEmployeeNameContainer context={props.context} />
                {/* <div className='row'>
                    {
                        reports && reports.length > 0 && Array.isArray(reports) ? reports.map((reportData) => (
                            reportData.report && reportData.report.length > 0 && <>
                                <div className='col-md-4'
                                    onClick={() => onCardClick(reportData)}
                                >
                                    <div className="card" data-toggle="modal" data-target="#modal1">
                                        <div className="card-body">
                                            {reportData.moduleName}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )) : <div className='col-md-4'><span>No Report Available</span></div>
                    }

                    <ReportModalContainer isOpen={isOpen} setIsOpen={setIsOpen} selectedReport={selectedReport} />

                </div> */}
                <div className="row">
                    {reports && reports.map((_report, index) => (
                        <div
                            key={_report.moduleName}
                            className="col-12 col-sm-12 col-md-12 col-lg-4"
                        >
                            {console.log("_report===>", _report)}
                            <div className="s-box">
                                <div className="srv-img">
                                    <img src={_reports} alt="" />
                                </div>
                                <h2>{props.context.t(_report.moduleName)}</h2>
                                {/* <span>{props.context.t(module.details)}</span> */}
                                <div>
                                    {(
                                        <div
                                            onClick={() => {
                                                // onServiceButtonClick(module.redirectLink);
                                                onCardClick(_report);
                                            }}
                                            className="r-more"
                                            data-toggle="tooltip"
                                            data-placement="bottom"
                                            title={"Report Suite"}
                                        >
                                            {/* {props.context.t(module.redirectLinkName)} */}
                                            {props.context.t("MyReports.Report.ReportSuite")}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                    }
                </div>
                <ReportModalContainer isOpen={isOpen} setIsOpen={setIsOpen}
                    selectedReport={selectedReport}
                    onLevelSelect={onLevelSelect}
                    levelItems={props.levelItems}
                    lstCompanyLevelData={props.lstCompanyLevelData}
                    regionList={props.regionList}
                    departmentList={props.departmentList}
                    onRegionSelect={onRegionSelect}
                    context={props.context}
                />
            </div>
            {/* </div> */}
        </>
    )
}

export default MyReportPage;